const assignToggleButtonStickySidebar = () => {
  const button = document.querySelector(".facet-sticky-button");
  const container = document.querySelector("main");
  if (!button) return;

  const matchMedia = window.matchMedia("(max-width: 968px)");
  if (matchMedia.matches) {
    button.setAttribute("aria-controls", "facets-drawer");
    button.setAttribute("aria-expanded", "false");
  } else {
    if (!container.dataset.stickyFilterInitialized) {
      container.dataset.stickyFilterInitialized = "true";
      container.classList.add("collection-sticky-filter-active");
      button.setAttribute("aria-expanded", "true");
    }

    button.addEventListener("click", () => {
      container.classList.toggle("collection-sticky-filter-active");
      button.setAttribute(
        "aria-expanded",
        container.classList.contains("collection-sticky-filter-active")
      );
    });
  }
};

async function insertSvgIntoSpan() {
  const spans = document.querySelectorAll("span[data-reference-image]");

  spans.forEach(async (span) => {
    const svgUrl = span.getAttribute("data-reference-image");

    try {
      const response = await fetch(svgUrl);

      if (response.ok) {
        const svgContent = await response.text();
        span.innerHTML = svgContent;
      } else {
        console.error(`No se pudo obtener el SVG de: ${svgUrl}`);
      }
    } catch (error) {
      console.error(`Error al obtener el SVG: ${error.message}`);
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  assignToggleButtonStickySidebar();
  insertSvgIntoSpan();

  document.addEventListener("facet:updated", function () {
    setTimeout(() => {
      assignToggleButtonStickySidebar();
      insertSvgIntoSpan();
    }, 0);
  });
});

class CartUpdater {
  constructor() {
    this.sectionId = 'template--18019935223850__main';
    this.init();
  }


  init() {
    const cartSection = document.querySelector('.shopify-section--main-cart')
    if (cartSection) {
      this.sectionId = cartSection.id.replace('shopify-section-', '');
    }

    const items = document.querySelectorAll('.action-change-cart');
    items.forEach(item => this.attachEvents(item));
  }

  attachEvents(item) {
    const decreaseBtn = item.querySelector('.quantity-decrease');
    const increaseBtn = item.querySelector('.quantity-increase');
    const input = item.querySelector('.quantity-input');
    const removeLink = item.querySelector('.remove-btn a');
    const lineItemData = JSON.parse(item.querySelector('.line-item-data')?.textContent || '{}');

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', () => {
        this.updateQuantity(lineItemData, parseInt(input.value) - 1);
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', () => {
        this.updateQuantity(lineItemData, parseInt(input.value) + 1);
      });
    }

    if (removeLink) {
      removeLink.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.removeItem(lineItemData);
      });
    }
  }

  updateQuantity(lineItemData, newQuantity) {
    const formData = {
      id: lineItemData.key,
      quantity: newQuantity
    };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
      .then(res => res.json())
      .then(() => this.refreshSection());
  }

  removeItem(lineItemData) {
    const updates = {
      [lineItemData.key]: 0
    };

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
      .then(res => res.json())
      .then(() => this.refreshSection());
  }

  refreshSection() {
    fetch(`${window.Shopify.routes.root}?sections=${this.sectionId}`)
      .then(res => res.json())
      .then(data => {
        const newHtml = data[this.sectionId];
        //console.log('🚀 -> newHtml:', newHtml)
        const container = document.getElementById(`shopify-section-${this.sectionId}`);
        //console.log('🚀 -> container:', container)
        if (container) {
          const temp = document.createElement('div');
          temp.innerHTML = newHtml;
          const newSection = temp.firstElementChild;
          container.replaceWith(newSection);
          this.init(); // Reasigna eventos
        }
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CartUpdater();
});

(function() {
  'use strict';
  
  function handleQuantityButtonClick(event) {
    const button = event.target.closest('.quantity-decrease, .quantity-increase');
    if (!button) return;
    
    const cartDrawer = button.closest('#cart-drawer');
    if (!cartDrawer) return;
    
    event.preventDefault();
    event.stopPropagation();
    
    const lineItemQuantity = button.closest('line-item-quantity');
    if (!lineItemQuantity) return;
    
    const lineItemKey = lineItemQuantity.getAttribute('data-line-key');
    if (!lineItemKey) return;
    
    const inputElement = lineItemQuantity.querySelector(`input[data-line-key="${lineItemKey}"]`);
    if (!inputElement) return;
    
    const currentQuantity = parseInt(inputElement.value) || 0;
    const maxQuantity = inputElement.getAttribute('max') ? parseInt(inputElement.getAttribute('max')) : null;
    const action = button.getAttribute('data-action');
    
    let newQuantity;
    if (action === 'decrease') {
      newQuantity = Math.max(0, currentQuantity - 1);
    } else if (action === 'increase') {
      newQuantity = currentQuantity + 1;
      if (maxQuantity && newQuantity > maxQuantity) {
        newQuantity = maxQuantity;
      }
    } else {
      return;
    }
    
    inputElement.value = newQuantity;
    
    const increaseBtn = lineItemQuantity.querySelector('.quantity-increase');
    if (increaseBtn) {
      if (maxQuantity && newQuantity >= maxQuantity) {
        increaseBtn.disabled = true;
      } else {
        increaseBtn.disabled = false;
      }
    }
    
    const decreaseBtn = lineItemQuantity.querySelector('.quantity-decrease');
    if (decreaseBtn) {
      decreaseBtn.disabled = newQuantity <= 0;
    }
    
    if (lineItemQuantity._changeLineItemQuantity) {
      lineItemQuantity._changeLineItemQuantity(lineItemKey, newQuantity);
    }
  }
  
  document.addEventListener('click', handleQuantityButtonClick);
})();

class CrossColor extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      tabs: ".cross_tabs_html",
      tab: ".tab",
    };

    this.state = {
      currentTab: "PACK",
      colors: [],
      variants: [],
      currentProduct: {},
      currentOptions: {},
      currentVariant: {},
      productsBundle: [],
      optionSelected: [],
      swatchSettings: [],
      variantsSelected: [],
      unavailableColors: [],
      lowStockWarnings: [],
      child_reference: null,
      swatch_config: [],
    };

    this.CDN_FILES = "/cdn/shop/files";

    this.variants = [];

    this.setAttribute('data-initialized', 'true');

    try {
      this.getColorJson();
      this.assignCurrentVariant();
      this.renderTabs();
      this.render();
    } catch (error) {
      console.error('CrossColor initialization error:', error);
      this.renderErrorState();
    }
  }

  renderErrorState() {
    this.innerHTML = `
      <div class="cross_tabs__wrapper">
        <div class="cross-color-error">
          <p>Unable to load color options. Please refresh the page.</p>
        </div>
      </div>
    `;
  }

  gotoActionSingle() {
    if (this.state.child_reference && this.state.child_reference.handle) {
      window.location.href = `/products/${this.state.child_reference.handle}`;
    } else {
      if (this.state.productsBundle && this.state.productsBundle.length > 0) {
        const currentId = this.state.currentProduct && this.state.currentProduct.id;
        const otherProduct = this.state.productsBundle.find(
          (p) => p.product && p.product.id !== currentId
        );
        const target = otherProduct || this.state.productsBundle[0];
        if (target && target.product) {
          window.location.href = `/products/${target.product.handle}`;
        } else {
          console.warn('No valid product bundle found for single action');
        }
      } else {
        console.warn('No valid product bundle found for single action');
      }
    }
  }

  getDefaultContent() {
    return `
    <div class="group-cross">
      <div class="label">Color: <span label-cross-color></span></div>
      <cross-color></cross-color>
    </div>
    `;
  }

  getDefaultVariantContent(label) {
    const { name, content } = label;

    return `
      <div class="group-cross" id="gcross-${name}">
        <div class="label">${name}: <span label-current-variant></span></div>
        ${content}
      </div>
    `;
  }

  renderTabs() {
    const hasValidChildReference = this.state.child_reference && this.state.child_reference.handle;
    
    const singleTabContent = hasValidChildReference 
      ? `<a href="/products/${this.state.child_reference.handle}" class="tab cross-tab uppercase ${this.state.currentTab === "SINGLE" ? "active" : ""}" data-tab="SINGLE">
          <span>Single</span>
        </a>`
      : `<button class="tab cross-tab uppercase ${this.state.currentTab === "SINGLE" ? "active" : ""}" data-tab="SINGLE">
          <span>Single</span>
        </button>`;

    return `
      <div class="tabs">
        ${singleTabContent}
        <button class="tab ${this.state.currentTab === "PACK" ? "active" : ""}" data-tab="PACK">
          <span>Pack</span>
        </button>
      </div>
    `;
  }

  addEventListenersTabs() {
    const crossTabsContainer = this.closest(".cross-tabs");
    if (!crossTabsContainer) return;

    // Use a single delegated listener on the container so it survives re-renders.
    // Guard against attaching more than once.
    if (crossTabsContainer._tabListenerAttached) return;
    crossTabsContainer._tabListenerAttached = true;

    crossTabsContainer.addEventListener("click", (event) => {
      const tab = event.target.closest(".tab[data-tab]");
      if (!tab) return;

      event.preventDefault();

      const tabType = tab.dataset.tab; // "SINGLE" or "PACK"
      this.state.currentTab = tabType;

      if (tabType === "SINGLE") {
        this.gotoActionSingle();
        return; // navigation is in progress — no need to re-render
      }

      this.render();
    });
  }

  addEventListenersPackLabel() {
    const colorGroups = document.querySelectorAll(".color-picket-group");
    if (!colorGroups || colorGroups.length === 0) return;
    
    colorGroups.forEach((div) => {
      div.addEventListener("click", (event) => {
        event.stopPropagation();
        const variantId = div.querySelector("[data-variant-id]")?.dataset
          .variantId;
        if (variantId) {
          this.assignCurrentVariantById(Number(variantId));
        }

        this.updatePreselectedColors();
        this.render();
        this.addEventListeners();
      });
    });

    const toggleButtons = this.querySelectorAll(".toggle-select-state");
    if (!toggleButtons || toggleButtons.length === 0) return;
    
    toggleButtons.forEach((button) => {
      const parent = button.closest(".color-cross-picket-group");
      if (!parent) return;
      
      parent.addEventListener("click", (event) => {
        event.stopPropagation();

        const select = parent.querySelector(".select-color-list");
        if (!select) return;

        this.querySelectorAll(".select-color-list[expanded]").forEach((el) => {
          if (el !== select) {
            el.removeAttribute("expanded");
          }
        });

        if (select.hasAttribute("expanded")) {
          select.removeAttribute("expanded");
        } else {
          select.setAttribute("expanded", "");
        }
      });
    });

    document.addEventListener("click", (event) => {
      if (!event.target.closest(".color-cross-picket-group")) {
        this.querySelectorAll(".select-color-list[expanded]").forEach((el) => {
          el.removeAttribute("expanded");
        });
      }
    });

    const colorPreviewRows = document.querySelectorAll(".select-color-list .row-color-preview");
    if (!colorPreviewRows || colorPreviewRows.length === 0) return;
    
    colorPreviewRows.forEach((div) => {
      div.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const currentColor = div.getAttribute("value");
        const number = div
          .closest(".select-color-list")
          .getAttribute("data-reference");
        //this.assignCurrentVariantById(Number(formatId));

        this.state.currentOptions = {
          ...this.state.currentOptions,
          [`color${number}`]: currentColor,
        };

        this.updateImageReference(currentColor);
        this.render();
        this.addEventListeners();
      });
    });
  }

  updatePreselectedColors() {
    if (!this.state.currentVariant || !this.state.currentVariant.title) return;
    
    const numberInputsColor = Number(
      (this.state.currentVariant.title || "").replace("Pack", "") || 0
    );
    const { variantsSelected } = this.state;
    const selectedSize = this.state.currentOptions.size;
    const defaultColor = this.state.colors[0];

    if (numberInputsColor > variantsSelected.length) {
      for (let i = variantsSelected.length + 1; i <= numberInputsColor; i++) {
        const colorKey = `color${i}`;
        const selectedColor =
          this.state.currentOptions[colorKey] || defaultColor;
        const newVariant = this.state.productsBundle
          .map((product) =>
            product.product.variants.find(
              (variant) =>
                variant.option1 === selectedColor &&
                variant.option2 === selectedSize
            )
          )
          .find(Boolean);

        if (newVariant) {
          variantsSelected.push(newVariant);
        }

        this.state.currentOptions[colorKey] = selectedColor;
      }
    } else if (numberInputsColor < variantsSelected.length) {
      this.state.variantsSelected = variantsSelected.slice(
        0,
        numberInputsColor
      );
      for (let i = numberInputsColor + 1; i <= variantsSelected.length; i++) {
        delete this.state.currentOptions[`color${i}`];
      }
    }
  }

  updateImageReference(currentColor) {
    if (!this.state.productsBundle || this.state.productsBundle.length === 0) return;
    
    const { featured_image, name } = this.state.productsBundle
      .map((product) =>
        product.product.variants.find(
          (variant) => variant.option1 == currentColor
        )
      )
      .find((variant) => variant !== undefined);
  
    const imageNode = document.querySelector(".product-gallery__media");
    if (!featured_image?.src || !imageNode) return;
  
    document.querySelector("body").classList.add("image-product-replaced");
  
    const baseUrl = featured_image.src.split("?")[0];
    const srcset = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200, 2400]
      .map(size => `${baseUrl}?width=${size} ${size}w`)
      .join(", ");
  
    imageNode.innerHTML = `
      <img 
        src="${baseUrl}?width=2400" 
        srcset="${srcset}" 
        width="auto" 
        height="auto" 
        loading="lazy" 
        alt="Image Variant for ${name}">
    `;
  }
  
  closeSelects() {
    document.querySelectorAll(".select-color-list").forEach((div) => {
      div.classList.remove("expanded");
    });
  }

  assignCurrentVariantById(id) {
    if (!this.state.currentProduct || !this.state.currentProduct.variants) return;
    
    this.state.currentVariant = this.state.currentProduct.variants.find(
      (variant) => variant.id === id
    );
  }

  getColorJson() {
    const container = document.querySelector("[data-cross-colors]");
    if (!container) {
      console.error('CrossColor: No data container found');
      throw new Error('No data container found');
    }
    
    let dataJson;
    try {
      dataJson = JSON.parse(container.innerHTML);
    } catch (error) {
      console.error('CrossColor: Invalid JSON data', error);
      throw new Error('Invalid JSON data');
    }

    const {
      colors_available,
      current_product,
      products_bundle,
      swatch_config,
      child_reference,
    } = {
      ...dataJson,
    };
    
    this.colors = colors_available ?? [];

    const arraySwatch = new Array();

    if (swatch_config && Array.isArray(swatch_config)) {
      swatch_config.forEach((config) => {
        if (config && config.swatch_parts) {
          let swatch = config.swatch_parts;
          if (Array.isArray(swatch) && swatch.length > 1) {
            swatch[1] = swatch[1].trim();
          }
          arraySwatch.push(swatch);
        }
      });
    }

    this.state.swatch_config = arraySwatch;

    const colors = new Set();

    if (products_bundle && Array.isArray(products_bundle)) {
      products_bundle.forEach((product) => {
        if (product && product.options) {
          const options = product.options.find((option) => option.name === "Color");
          if (options && options.values) {
            options.values.forEach((value) => colors.add(value));
          }
        }
      });
    }

    const uniqueColors = Array.from(colors);

    this.state = {
      ...this.state,
      currentProduct: current_product || {},
      colors: uniqueColors,
      productsBundle: products_bundle || [],
      swatch_config: arraySwatch,
      child_reference: child_reference,
    };
  }

  static get observedAttributes() {
    return ["variants"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "variants") {
      try {
        this.variants = JSON.parse(newValue);
      } catch (e) {
        console.error("Invalid variants JSON", e);
      }
    }
  }

  connectedCallback() {
    try {
      this.initializeDefaultVariant();
      this.stateCTA();
      this.render();
      this.addEventListeners();
    } catch (error) {
      console.error('CrossColor connectedCallback error:', error);
      this.renderErrorState();
    }
  }

  initializeDefaultVariant() {
    if (this.state.colors.length > 0) {
      const defaultColor = this.state.colors[0];
      const numberInputsColor = Number(
        (this.state.currentVariant?.title || "").replace("Pack", "") || 0
      );

      this.state.currentOptions = Object.fromEntries(
        Array.from({ length: numberInputsColor }, (_, i) => [
          `color${i + 1}`,
          defaultColor,
        ])
      );
    }

    const sizes = new Set();
    if (this.state.productsBundle && Array.isArray(this.state.productsBundle)) {
      this.state.productsBundle.forEach((product) => {
        if (product && product.options) {
          const options = product.options.find((option) => option.name === "Size");
          if (options && options.values) {
            options.values.forEach((value) => sizes.add(value));
          }
        }
      });
    }

    const uniqueSizes = Array.from(sizes);
    if (uniqueSizes.length > 0) {
      this.state.currentOptions.size = uniqueSizes[0];
      this.updateSelectedVariants();
    }

    requestAnimationFrame(() => {
      const firstSizeInput = this.querySelector(
        `input[name="size"][value="${this.state.currentOptions.size}"]`
      );
      if (firstSizeInput) {
        firstSizeInput.checked = true;
      }
    });
  }

  updateSelectedOption(optionName, optionValue) {
    this.state.currentOptions = {
      ...this.state.currentOptions,
      [optionName]: optionValue,
    };
  }

  addEventListeners() {
    const selects = this.querySelectorAll("select");
    if (!selects || selects.length === 0) return;
    
    selects.forEach((select, index) => {
      select.addEventListener("change", (event) => {
        const selectedColor = event.target.value;
        const colorInput = this.querySelector(`#color${index + 1}`);
        if (colorInput) {
          colorInput.value = selectedColor;
        }
        this.filterVariants(selectedColor);
      });
    });
  }

  addEventListenersInputs() {
    const sizeInputs = this.querySelectorAll("input[name='size']");
    if (!sizeInputs || sizeInputs.length === 0) return;
    
    sizeInputs.forEach((input) => {
      input.addEventListener("change", (event) => {
        const selectedSize = event.target.value;
        this.updateSelectedOption("size", selectedSize);
        this.updateSelectedVariants();
        this.render();
        this.addEventListeners();
      });
    });
  }

  updateSelectedVariants() {
    const selectedSize = this.state.currentOptions.size;
    const selectedColor = this.state.currentOptions.color1;
    if (!selectedSize || !this.state.productsBundle) return;

    this.state.variantsSelected = this.state.productsBundle
      .map((product) =>
        product.product.variants.find(
          (variant) =>
            variant.option1 === selectedColor &&
            variant.option2 === selectedSize
        )
      )
      .filter(Boolean);
  }

  filterVariants(color) {
    const availableVariants = this.variants.filter(
      (variant) => variant.color === color && variant.available
    );

    this.closeSelects();
  }

  getColorBySwatchSettings(color) {
    if (!this.state.swatch_config || !Array.isArray(this.state.swatch_config)) {
      return null;
    }

    return this.state.swatch_config.find((swatch) => {
      if (!swatch || !swatch[0]) return false;

      const label = swatch[0].trim();

      return label === color;
    });
  }

  getColorReference(index) {
    const colorOption = this.state.currentOptions[`color${index + 1}`];
    const colorBySwatchSettings = this.getColorBySwatchSettings(colorOption);

    if (!colorBySwatchSettings) {
      return { type: "hex", value: "#000000" };
    }

    const isHexa = colorBySwatchSettings[1].startsWith("#");

    return {
      type: isHexa ? "hex" : "image",
      value: isHexa
        ? colorBySwatchSettings[1]
        : `${this.CDN_FILES}/${colorBySwatchSettings[1]}`,
    };
  }

  getLabelFromOption(i) {
    const label = `color${i + 1}`;
    return this.state.currentOptions[label] || "Select";
  }

  getLabelorImageWithColor(color) {
    const colorBySwatchSettings = this.getColorBySwatchSettings(color);
    if (!colorBySwatchSettings) {
      return color;
    }

    return colorBySwatchSettings[1].startsWith("#")
      ? `<div class="box-swatch-preview" style="background-color: ${colorBySwatchSettings[1]}"></div>`
      : `<img class="box-swatch-preview" src="${this.CDN_FILES}/${colorBySwatchSettings[1]}" alt="${color}" />`;
  }

  renderCrossColorInputs() {
    if (!this.state.currentVariant) {
      return '';
    }
    
    let numberInputsColor = 0;
    
    if (this.state.currentVariant.title) {
      numberInputsColor = Number(
        (this.state.currentVariant.title || "").replace("Pack", "") || 0
      );
    }
    
    if (numberInputsColor === 0) {
      numberInputsColor = 1;
    }

    return `
      ${Array.from({ length: numberInputsColor }, (_, i) => {
      const colorRef = this.getColorReference(i);
      const isSingleColor = this.state.colors.length === 1;

      const htmlMultipleColor = !isSingleColor
        ? `<button class="toggle-select-state">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none">
              <path d="M9 1L5 5L1 1" stroke="#1D1D1D" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
          <div class="select-color-list" data-reference="${i + 1}" id="select${i + 1}">
            ${this.state.colors.map((color) => {
              const colorRef = this.getLabelorImageWithColor(color);
              return `
                <div class="flex flex-row row-color-preview" value="${color}">
                  <div class="swatch-value">${colorRef}</div>
                  <div class="swatch-label">${color}</div>
                </div>`;
              })
            .join("")}
          </div>`
        : ``;


      return `
        <div class="cross-color-picker">
          <label for="color${i + 1}">${this.getLabelFromOption(i)}</label>
          <div class="color-cross-picket-group ${isSingleColor ? "single-color" : ""}">
            ${colorRef.type === "hex"
              ? `<input type="color" name="color" id="color${i + 1}" value="${colorRef.value}" disabled />`
              : `<div class="color-preview" style="background-image: url('${colorRef.value}');"></div>`
            }
            ${htmlMultipleColor}
          </div>
        </div>`;
    }).join("")}
    `;
  }

  renderContentVariantByPacks() {
    const product = this.state.currentProduct;
    const currentVariant = this.state.currentVariant;
    
    if (!product) {
      return '<div class="content--tab__pack">No product data available</div>';
    }
    
    if (!product.options || !Array.isArray(product.options) || product.options.length === 0) {
      return '<div class="content--tab__pack">No product options available</div>';
    }
    
    const label = product.options[0];

    const isSingleColor = this.state.colors.length === 1;
    const firstColor = this.state.colors[0] || 'No color available';

    if (!product.variants || !Array.isArray(product.variants) || product.variants.length === 0) {
      return '<div class="content--tab__pack">No product variants available</div>';
    }
    
    return `
      <div class="content--tab__pack flex flex-row">
        <div class="option-title">
          <span>${label}</span>
        </div>
        ${product.variants
        .map(
          (variant) => `
              <div class="pack-color-selector"> 
                <div class="color-picket-group ${variant.id == currentVariant.id ? "active" : ""
            }">
                  <input type="hidden" data-variant-id=${variant.id} id="pack${variant.id
            }" value="${variant.title}" />
                  <label for="pack${variant.id}">${variant.title}</label>
                </div>
              </div>
            `
        )
        .join("")}
      </div>

      <div class="content--tab__cross-wrapper">
        <div class="option-title">
          <span>Color: ${firstColor}</span>
        </div>
        ${!isSingleColor ? this.renderCrossColorInputs() : ''}
      </div>
    `;
  }

  assignCurrentVariant() {
    if (!this.state.currentProduct || !this.state.currentProduct.variants || this.state.currentProduct.variants.length === 0) {
      console.warn('CrossColor: No product variants available');
      return;
    }
    this.state.currentVariant = this.state.currentProduct.variants[0];
  }

  renderContent() {
    const defaultContent = `
      <div class="content--tab__cross"></div>
    `;

    return this.state.currentTab === "SINGLE"
      ? defaultContent
      : this.renderContentVariantByPacks();
  }

  renderBadge() {
    if (!this.state.currentVariant) return '';
    
    const variant = this.state.currentVariant;
    const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    
    if (!isOnSale) return '';
    
    const discountMode = 'saving';
    const formId = 'product-form-7641745129514-template--17956848304170__main';
    
    let savings;
    if (discountMode === 'percentage') {
      const percentage = ((variant.compare_at_price - variant.price) / variant.compare_at_price * 100).toFixed(0);
      savings = `Save ${percentage}%`;
    } else {
      const savingsAmount = (variant.compare_at_price - variant.price) / 100;
      savings = `Save $${savingsAmount.toFixed(2)}`;
    }
    
    return `<on-sale-badge discount-mode="${discountMode}" form="${formId}" class="badge badge--on-sale">${savings}</on-sale-badge>`;
  }

  renderBadgeInPrice() {
    if (!this.state.currentVariant) return;
    
    const variant = this.state.currentVariant;
    const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    
    if (!isOnSale) return;
    
    const discountMode = 'saving';
    const formId = 'product-form-7641745129514-template--17956848304170__main';
    
    const savingsAmount = (variant.compare_at_price - variant.price) / 100;
    const savings = `Save $${savingsAmount.toFixed(2)}`;
    
    const badgeHtml = `<on-sale-badge discount-mode="${discountMode}" form="${formId}" class="badge badge--on-sale">${savings}</on-sale-badge>`;
    
    const priceElements = document.querySelectorAll('.product-info__price, .mobile-product-info .product-info__price');
    priceElements.forEach(priceElement => {
      if (priceElement && !priceElement.querySelector('.badge--on-sale')) {
        priceElement.insertAdjacentHTML('beforeend', badgeHtml);
        priceElement.classList.add('has-badge');
      }
    });
  }

  stateCTA() {
    const buttons = document.querySelector("buy-buttons");
    if (buttons) {
      buttons.classList.add("hidden");
    }
  }

  checkProductsAvailable() {
    const { size, ...colors } = this.state.currentOptions;
    const currentProductID = this.state.currentProduct.id;
    const selectedVariants = [];
    const unavailableColors = [];
    const lowStockWarnings = [];

    if (!this.state.productsBundle || !Array.isArray(this.state.productsBundle)) {
      return;
    }

    this.state.productsBundle.forEach((product) => {
      if (product.product.id === currentProductID) {
        return;
      }
      Object.values(colors).forEach((color) => {
        const variant = product.product.variants.find(
          (variant) => variant.option1 == color && variant.option2 === size
        );

        //error state messages
        if (variant) {
          selectedVariants.push(variant);
          if (!variant.available) {
            unavailableColors.push(`${color} / ${size}`);
          }
          if (variant.stock < 5) {
            lowStockWarnings.push(
              `Only ${variant.stock} pcs are available from ${color} / ${size}`
            );
          }
        } else if (size) {
          unavailableColors.push(`${color} / ${size}`);
        }
      });
    });

    this.state = {
      ...this.state,
      variantsSelected: selectedVariants,
      unavailableColors,
      lowStockWarnings,
    };
  }

  renderCTA() {
    this.checkProductsAvailable();

    // Situación actual del estado
    const hasValidSelections = this.state?.variantsSelected.length > 0;
    const hasUnavailableSelections = this.state?.unavailableColors?.length > 0;
    const allVariantsAvailable = this.state.variantsSelected.every(
      (variant) => variant.available
    );

    // Criterio: desactivar si NO hay selecciones válidas
    // o si alguna de las selecciones del pack está OOS.
    const shouldDisable = !hasValidSelections || hasUnavailableSelections || !allVariantsAvailable;

    const label = shouldDisable ? "Not available" : "Add to cart";

    const unavailableText = hasUnavailableSelections || !allVariantsAvailable
      ? `<div class="unavailable">Not available: ${this.state?.unavailableColors?.join(
          ", "
        )}</div>`
      : "";

    const lowStockText =
      this.state.lowStockWarnings?.length > 0
        ? `<div class="low-stock">${this.state.lowStockWarnings?.join("<br>")}</div>`
        : "";

    return `
      <div class="cta">
        <button 
          class="button primary-black cta__button cta_button_cross ${shouldDisable ? "disabled" : ""}"
          ${shouldDisable ? "disabled aria-disabled='true'" : ""}
        >
          ${label}
        </button>
        ${unavailableText}
        ${lowStockText}
      </div>
    `;
  }


  async addVariants() {
    const items = this.state.variantsSelected.map((variant) => ({
      id: variant.id,
      quantity: 1,
    }));

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items,
          sections:
            "cart-count, variant-added, sections--17218834694186__cart-drawer",
        }),
      });

      if (!response.ok) {
        throw new Error("Error al agregar productos al carrito");
      }

      const data = await response.json();
      const cart = await fetch("/cart.js", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const cart_data = await cart.json();

      document.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "line-item:change",
            cart: cart_data,
          },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cart_data,
          },
        })
      );

      const cartDrawerButton = document.querySelector('[aria-controls="cart-drawer"]');
      if (cartDrawerButton) {
        cartDrawerButton.click();
      }
      return data;
    } catch (error) {
      console.error("Error:", error);
    }
  }

  formatMoney(cents, currency = "$") {
    return currency + (cents / 100).toFixed(2);
  }

  updateTotalPrice() {
    const priceNodes = [
      document.querySelector(".product-info .product-info__price"),
      document.querySelector(".mobile-product-info .product-info__price"),
    ].filter(Boolean);

    if (priceNodes.length === 0) {
      console.warn("No se encontraron los elementos de precio en el DOM.");
      return;
    }

    const variant = this.state.currentVariant;

    if (!variant) {
      console.warn("No se encontró la variante actual.");
      return;
    }

    const totalPrice = parseFloat(variant.price) || 0;
    const comparePrice = parseFloat(variant.compare_at_price) || 0;

    const content = `
    <span class="pdp-price ${comparePrice > 0 ? "line-through" : ""}">
      ${this.formatMoney(comparePrice)}
    </span>
    ${totalPrice > 0
        ? `<span class="pdp-compare-price text-on-sale">${this.formatMoney(totalPrice)}</span>`
        : ""
      }
  `;

    const contentEmpty = `
    <span class="pdp-compare-price">${this.formatMoney(totalPrice)}</span>
  `;

    const markup = comparePrice > 0 ? content : contentEmpty;
    priceNodes.forEach((node) => {
      node.classList.remove("has-badge");
      node.innerHTML = markup;
    });

    this.renderBadgeInPrice();
  }


  assignEventSubmit() {
    const submitButton = this.querySelector(".cta_button_cross");
    if (!submitButton) return;
    
    submitButton.addEventListener("click", () => {
      this.addVariants();
    });
  }

  renderContentBySize() {
    const sizes = new Set();

    if (this.state.productsBundle && Array.isArray(this.state.productsBundle)) {
      this.state.productsBundle.forEach((product) => {
        if (product && product.options) {
          const options = product.options.find((option) => option.name === "Size");
          if (options && options.values) {
            options.values.forEach((value) => sizes.add(value));
          }
        }
      });
    }

    const uniqueSizes = Array.from(sizes);
    const currentSize = this.state.currentOptions["size"];

    if (uniqueSizes.length === 0) {
      return '<div class="content--tab__size">No sizes available</div>';
    }

    return `
      <div class="content--tab__size">
        <div class="option-title">
          <span>Size</span>
        </div>
        ${uniqueSizes
        .map(
          (size) => `
              <div class="size-selector">
                <input type="radio" name="size" id="size-${size}" value="${size}" ${currentSize === size ? "checked" : ""
            } />

                <label class="size-label-wrapper ${currentSize === size ? "active" : ""
            }" for="size-${size}">${size}</label>
              </div>
            `
        )
        .join("")}
      </div>
    `;
  }

  render() {
    try {
      const tabsHtml = this.renderTabs();
      const contentHtml = this.renderContent();
      const sizeHtml = this.renderContentBySize();
      const ctaHtml = this.renderCTA();
      
      this.innerHTML = `
       <div class="cross_tabs__wrapper">
          ${tabsHtml}
          ${contentHtml}
          ${sizeHtml}
          ${ctaHtml}
        </div>
      `;

      this.addEventListenersTabs();
      this.addEventListenersPackLabel();
      this.addEventListenersInputs();
      this.assignEventSubmit();
      this.updateTotalPrice();
      this.renderBadgeInPrice();
    } catch (error) {
      console.error('CrossColor render error:', error);
      this.renderErrorState();
    }
  }
}

customElements.define("cross-color", CrossColor);

class OnSaleBadge extends HTMLElement {
  constructor() {
    super();
    this.discountMode = this.getAttribute('discount-mode') || 'saving';
    this.formId = this.getAttribute('form');
  }

  connectedCallback() {
    this.updateBadge();
  }

  updateBadge() {
    if (this.formId) {
      const form = document.getElementById(this.formId);
      if (form) {
        const variantId = form.querySelector('input[name="id"]')?.value;
        if (variantId) {
          this.updateBadgeForVariant(variantId);
        }
      }
    }
  }

  updateBadgeForVariant(variantId) {
    const variant = this.findVariantById(variantId);
    if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
      this.style.display = 'inline-block';
      this.updateBadgeText(variant);
    } else {
      this.style.display = 'none';
    }
  }

  findVariantById(variantId) {
    const productData = document.querySelector('[data-product-json]');
    if (productData) {
      try {
        const product = JSON.parse(productData.textContent);
        return product.variants.find(v => v.id.toString() === variantId.toString());
      } catch (error) {
        console.error('Error parsing product data:', error);
      }
    }
    return null;
  }

  updateBadgeText(variant) {
    if (this.discountMode === 'percentage') {
      const percentage = ((variant.compare_at_price - variant.price) / variant.compare_at_price * 100).toFixed(0);
      this.textContent = `Save ${percentage}%`;
    } else {
      const savingsAmount = (variant.compare_at_price - variant.price) / 100;
      this.textContent = `Save $${savingsAmount.toFixed(2)}`;
    }
  }
}

customElements.define("on-sale-badge", OnSaleBadge);

document.addEventListener("DOMContentLoaded", function () {
  const crossColorElements = document.querySelectorAll('cross-color');
  
  crossColorElements.forEach((element, index) => {
    if (!element.shadowRoot) {
      //console.log(`CrossColor element ${index} is properly connected`);
    }
  });
  
  setTimeout(() => {
    const uninitializedElements = document.querySelectorAll('cross-color:not([data-initialized])');
    if (uninitializedElements.length > 0) {
      uninitializedElements.forEach((element) => {
        try {
          if (customElements.get('cross-color')) {
            element.setAttribute('data-initialized', 'true');
            //console.log('Re-initialized cross-color element');
          }
        } catch (error) {
          console.error('Failed to re-initialize cross-color element:', error);
        }
      });
    }
  }, 1000);
});

document.addEventListener("DOMContentLoaded", function () {
  const galleryWrapper = document.querySelector(".product-gallery");
  function applyMinHeight() {
      if (!galleryWrapper) return;
      if (window.innerWidth < 640) {
          galleryWrapper.style.minHeight = galleryWrapper.offsetHeight + "px";
      } else {
          galleryWrapper.style.minHeight = "";
          window.removeEventListener("resize", applyMinHeight);
      }
  }
  function handleResize() {
      if (window.innerWidth < 640) {
          applyMinHeight();
      } else {
          galleryWrapper.style.minHeight = "";
          window.removeEventListener("resize", handleResize);
      }
  }
  // Apply only if width is below 640px initially
  if (window.innerWidth < 640) {
      applyMinHeight();
      window.addEventListener("resize", handleResize);
  }
});
